function ischecked(elementname) {
  var i;
  var fabs; 
  var ischeck = 0;
  fabs = document.getElementsByName(elementname);
  for (i = 0; i < fabs.length; i++) {
    if(fabs[i].checked) {
        ischeck = 1; 
    }
  }
  return ischeck;
}


function delete_project(customer_id1) {
 
   

  if (confirm("Are you sure you want to delete?")) {

    if (ischecked('yogawaistbandchecklist')) {
        $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'YogaWaistband' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
  	}
  	if (ischecked('addskirtchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'AddSkirt' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
	}
    if (ischecked('addgatheredskirtchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'GatheredSkirtCalculator' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
	}
	if (ischecked('elasticwaistbandchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'ElasticWaistband' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
	}
  if (ischecked('neckbandchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'NeckbandCalculator' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
	}
	if (ischecked('leggingschecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Leggings' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
	if (ischecked('panelleggingschecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'PanelLeggings' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
	if (ischecked('testchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Test' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('tshirtchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Tshirt' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('underwearchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Underwear' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    } 
    if (ischecked('sportsbrachecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'SportsBra' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('crossoverbrachecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'CrossoverBra' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('joggerschecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Joggers' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('joggerstestchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'TestJoggers' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('splashpantschecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'SplashPants' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('raglanchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Raglan' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('jeanschecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Jeans' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('bunnychecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Bunny' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('sleeperchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Sleeper' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('ridingtightschecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'RidingTights' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('toquechecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Toque' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('earschecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'Ears' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('witchhatchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'WitchHat' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('nursingtankchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'NursingTank' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('pencilskirtchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'PencilSkirt' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('mehdaichecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'MehDai' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('flannelpjpantschecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'FlannelPJPants' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
    if (ischecked('swimsuitchecklist')) {
      $.get('https://metafields-manager.thebestagency.com/proxy/metafield', { 
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        key: 'SwimSuit' }, function (d) { console.log(d); delete_project2(d,customer_id1); });
    }
  }
}

function delete_project2(cur_meta,customer_id1) {

  var i;
  var j;
  var cur_array = cur_meta.value;
  var tmp_array = [];
  var key = cur_meta.key;
  var cur_array = cur_array.split(",");
  var lngth = cur_array.length; 
  if (lngth == 1) {
    cur_array=[];
  }
  var entries;
  if (key == "Skirt") {
    entries = 11; //there are 11 entries per project
  } else if (key == "YogaWaistband") {
    entries = 9;
  } else if (key == "AddSkirt") {
    entries = 10;
  } else if (key == "GatheredSkirtCalculator") {
    entries = 13;
  } else if (key == "ElasticWaistband") {
    entries = 8;
  } else if (key == "NeckbandCalculator") {
    entries = 15;
  } else if (key == "Leggings") {
    entries = 23;
  } else if (key == "PanelLeggings") {
    entries = 27;
  } else if (key == "Tshirt") {
    entries = 31;
  } else if (key == "Underwear") {
    entries = 24;
  } else if (key == "SportsBra") {
    entries = 28;
  } else if (key == "CrossoverBra") {
    entries = 28;
  } else if (key == "Joggers" || key == "FlannelPJPants") {
    entries = 27;
  } else if (key == "SplashPants") {
    entries = 24;
  } else if (key == "SwimSuit") {
    entries = 37;
  } else if (key == "Raglan") {
    entries = 39;
  } else if (key == "Jeans") {
    entries = 24;
  } else if (key == "Bunny") {
    entries = 17;
  } else if (key == "Sleeper") {
    entries = 17;
  } else if (key == "RidingTights") {
    entries = 27;
  } else if (key == "Toque") {
    entries = 25;
  } else if (key == "Ears") {
    entries = 17;
  } else if (key == "WitchHat") {
    entries = 11;
  } else if (key == "NursingTank") {
    entries = 11;
  } else if (key == "PencilSkirt") {
    entries = 25;
  } else if (key == "MehDai") {
    entries = 20;
  }
  
  var numofentries = cur_array.length/entries; 
  
  if (numofentries>0) {
    
    if (key == "Skirt") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("skirtcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
      type: 'customer', 
      id: customer_id1, 
      shop: 'apostrophe-patterns', 
      namespace: 'global', 
      key: 'Skirt',
      value: new_meta2 }, function (d) { console.log(d); });
      
      reload1();

    } else if (key == "YogaWaistband") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("yogacheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
      type: 'customer', 
      id: customer_id1, 
      shop: 'apostrophe-patterns', 
      namespace: 'global', 
      key: 'YogaWaistband',
      value: new_meta2 }, function (d) { console.log(d); });
      
      reload1();
    } else if (key == "AddSkirt") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("addskirtcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'AddSkirt',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1();
    } else if (key == "GatheredSkirtCalculator") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("addgatheredskirtcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'GatheredSkirtCalculator',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1();
    } else if (key == "ElasticWaistband") {
      
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("elasticcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'ElasticWaistband',
        value: new_meta2 }, function (d) { console.log(d); });

      reload1();
    } else if (key == "NeckbandCalculator") {
      
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("neckbandcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'NeckbandCalculator',
        value: new_meta2 }, function (d) { console.log(d); });

      reload1();
    } else if (key == "Leggings") {
      
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("leggingscheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Leggings',
        value: new_meta2 }, function (d) { console.log(d); });

      reload1();
    } else if (key == "PanelLeggings") {
      
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("panelleggingscheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'PanelLeggings',
        value: new_meta2 }, function (d) { console.log(d); });

      reload1();
    } else if (key == "Test") {
      
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("testcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Test',
        value: new_meta2 }, function (d) { console.log(d); });

      reload1();
    } else if (key == "Tshirt") {
      
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("tshirtcheck" + i).checked == false) {
          //window.alert(i);
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Tshirt',
        value: new_meta2 }, function (d) { console.log(d); });

      
      reload1(customer_id1);
    } else if (key == "Underwear") {
      
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("underwearcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      

      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Underwear',
        value: new_meta2 }, function (d) { console.log(d); });

      
      reload1(customer_id1);
    } else if (key == "SportsBra") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("sportsbracheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'SportsBra',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "CrossoverBra") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("crossoverbracheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'CrossoverBra',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "Joggers") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("joggerscheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Joggers',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "TestJoggers") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("joggerstestcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'TestJoggers',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "SplashPants") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("splashpantscheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'SplashPants',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "Raglan") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("raglancheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Raglan',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "Jeans") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("jeanscheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Jeans',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "Bunny") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("bunnycheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Bunny',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "Sleeper") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("sleepercheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Sleeper',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "RidingTights") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("ridingtightscheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'RidingTights',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "Toque") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("toquecheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Toque',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "Ears") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("earscheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'Ears',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "WitchHat") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("witchhatcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'WitchHat',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "NursingTank") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("nursingtankcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'NursingTank',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "PencilSkirt") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("pencilskirtcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'PencilSkirt',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "MehDai") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("mehdaicheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'MehDai',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "FlannelPJPants") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("flannelpjpantscheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'FlannelPJPants',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    } else if (key == "SwimSuit") {
      for (i=0; i<numofentries; i++) {
        if (document.getElementById("swimsuitcheck" + i).checked == false) {
          for (j=0; j<entries; j++) {
          	tmp_array.push(cur_array[i*entries + j]);
          }
        }
      }
      if (tmp_array.length == 0) { //because can't set meta to nothing
        tmp_array[0]="-";
      }
      new_meta2 = tmp_array.join();
      
      $.post('https://metafields-manager.thebestagency.com/proxy/metafield', {
        type: 'customer', 
        id: customer_id1, 
        shop: 'apostrophe-patterns', 
        namespace: 'global', 
        key: 'SwimSuit',
        value: new_meta2 }, function (d) { console.log(d); });
      reload1(customer_id1);
    }         
  
  }
}

function reload1(customer_id1) {
  setTimeout(function(){
    //load_projects(customer_id1);
    location.reload(true);
  },2000);

}

function checkboxcheck(numofentries,checkboxname) {
  var i;
  var ischecked=0; //boolean
  for (i=0; i<numofentries; i++) {
    if (document.getElementById(checkboxname + i).checked == true) {
      ischecked=1;
    }
  }
  return ischecked;
}